import {css} from 'lit-element'; export default css`:host{grid-template-areas:"route-not-found";grid-template-columns:100%;grid-template-rows:auto}`;
    